import React, { useEffect } from 'react';
import Switch from 'react-bootstrap-switch';
import Label from './Label';
import wrapperField from './wrapperField';
import { noop } from '../../helperFunctions';

// NOTE: custom styles for this component are defined in app/javascript/components/inputs/toggleSwitch/index.module.scss
// there is also a 'pull-right' wrapper for this switch (?)

const toggleSwitch = ({
  input,
  label,
  defaultValue,
  disabled,
  onText,
  offText,
  onColor,
  wrapperClass,
  labelWidth,
  handleWidth,
  mainLabel,
  labelClass,
  subLabel,
  subLabelClass,
  skipDefault = false,
  bsSize = '',
  meta: { pristine, touched, error, warning },
  textOnly,
  shouldAllowChange,
  onChange = noop,
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (pristine && defaultValue !== undefined && !skipDefault) {
      input.onChange(String(defaultValue) === 'true');
    }
  });

  const handleChange = (el, state) => {
    if (typeof shouldAllowChange === 'function') {
      const allowed = shouldAllowChange(state);
      if (!allowed) {
        return; // prevent toggle
      }
    }
    onChange(state);
    input.onChange(state);
  };

  return (
    <React.Fragment>
      <Label
        {...{ input, label: mainLabel, labelClass, subLabel, subLabelClass }}
      />
      <span className={`main-field-cont ${textOnly ? 'text-only' : ''}`}>
        <Switch
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...input}
          disabled={disabled}
          onChange={handleChange}
          labelText={label}
          animate={false}
          onText={onText}
          offText={offText}
          inverse
          bsSize={bsSize}
          onColor={onColor}
          wrapperClass={wrapperClass}
          labelWidth={labelWidth}
          handleWidth={handleWidth}
        />
        {touched &&
          ((error && <span className="error">{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </span>
    </React.Fragment>
  );
};

export default wrapperField(toggleSwitch);
